import { computed, inject, Injectable } from '@angular/core';
import { SonaAuthApiFacade } from '@sona/angular-auth-api';
import { SUPABASE } from '@sona/angular-auth-domain';

/**
 * A facade for managing onboarding state for the current user.
 */
@Injectable({
    providedIn: 'root'
})
export class SonaOnboardingFacade {
    private readonly _supabase = inject(SUPABASE);
    private readonly _authFacade = inject(SonaAuthApiFacade);

    readonly hasSeenOnboardingPage = computed<boolean>(() => {
        const meta = (this._authFacade.user()?.user_metadata ?? {}) as Record<string, unknown>;
        return Boolean(typeof meta['onboardingSeenAt'] === 'string' && meta['onboardingSeenAt']);
    });

    readonly showOnboardingBanner = computed<boolean>(() => {
        const user = this._authFacade.user();

        if (!user) {
            return false;
        }

        const meta = (user.user_metadata ?? {}) as Record<string, unknown>;
        const bannerClosed = Boolean(typeof meta['onboardingBannerClosedAt'] === 'string' && meta['onboardingBannerClosedAt']);
        return !bannerClosed;
    });

    async markOnboardingPageSeen() {
        await this._supabase.auth.updateUser({ data: { onboardingSeenAt: new Date().toISOString() } });
    }

    async dismissOnboardingBanner() {
        await this._supabase.auth.updateUser({ data: { onboardingBannerClosedAt: new Date().toISOString() } });
    }
}
